{
  "starters": {
    "rewards": [
      {
        "key": "homework",
        "name": "Dever em dia",
        "emoji": "✓"
      },
      {
        "key": "help",
        "name": "Ajudou colegas",
        "emoji": "🤝"
      },
      {
        "key": "cooperate",
        "name": "Trabalho em grupo",
        "emoji": "🌿"
      },
      {
        "key": "focus",
        "name": "Foco na aula",
        "emoji": "👀"
      },
      {
        "key": "raise-hand",
        "name": "Levantou a mão",
        "emoji": "✋"
      },
      {
        "key": "challenge",
        "name": "Desafio concluído",
        "emoji": "⭐"
      }
    ],
    "reminders": [
      {
        "key": "chatting",
        "name": "Conversa paralela",
        "emoji": "💬"
      },
      {
        "key": "materials",
        "name": "Sem material",
        "emoji": "🎒"
      },
      {
        "key": "late-homework",
        "name": "Dever atrasado",
        "emoji": "📋"
      },
      {
        "key": "disturbing",
        "name": "Fora da atividade",
        "emoji": "🔔"
      }
    ],
    "homework": [
      {
        "key": "language-workbook",
        "name": "Português",
        "emoji": "📖"
      },
      {
        "key": "language-writing",
        "name": "Ortografia",
        "emoji": "✏️"
      },
      {
        "key": "math-workbook",
        "name": "Matemática",
        "emoji": "🧮"
      },
      {
        "key": "contact-book",
        "name": "Agenda",
        "emoji": "📝"
      }
    ],
    "daily": [
      {
        "key": "morning-reading",
        "name": "Acolhida",
        "emoji": "☀️"
      },
      {
        "key": "reading",
        "name": "Ler 20 min",
        "emoji": "📚"
      },
      {
        "key": "water",
        "name": "Garrafinha",
        "emoji": "💧"
      },
      {
        "key": "cleaning",
        "name": "Mesa limpa",
        "emoji": "🧹"
      },
      {
        "key": "materials",
        "name": "Mochila",
        "emoji": "🎒"
      }
    ],
    "store": [
      {
        "key": "sticker",
        "name": "Adesivo",
        "emoji": "🌈",
        "points": 5
      },
      {
        "key": "library-first",
        "name": "1º na biblioteca",
        "emoji": "📚",
        "points": 8
      },
      {
        "key": "helper",
        "name": "Ajudante do dia",
        "emoji": "🤝",
        "points": 10
      },
      {
        "key": "seat",
        "name": "Escolher lugar",
        "emoji": "🪑",
        "points": 15
      },
      {
        "key": "social-treat",
        "name": "Lanche com a prof",
        "emoji": "🍱",
        "points": 15
      },
      {
        "key": "homework-pass",
        "name": "Vale sem dever",
        "emoji": "📝",
        "points": 20
      },
      {
        "key": "mystery",
        "name": "Prêmio surpresa",
        "emoji": "🎁",
        "points": 25
      },
      {
        "key": "top-prize",
        "name": "Cadeira da prof",
        "emoji": "👑",
        "points": 30
      }
    ],
    "instructions": [
      {
        "key": "ready",
        "title": "Preparar para a aula",
        "steps": [
          "Pegue o livro e o estojo",
          "Abra na página anotada na lousa",
          "Olhos e atenção na professora"
        ]
      },
      {
        "key": "group",
        "title": "Conversa em grupo",
        "steps": [
          "Cada um fala na sua vez",
          "Anotem a resposta do grupo",
          "Escolham um porta-voz"
        ]
      },
      {
        "key": "finished",
        "title": "Terminou mais cedo?",
        "steps": [
          "Confira se colocou seu nome",
          "Entregue a atividade",
          "Leia um livro em silêncio"
        ]
      },
      {
        "key": "pack-up",
        "title": "Hora da saída",
        "steps": [
          "Guarde tudo na mochila",
          "Arrume a cadeira e recolha o lixo do chão",
          "Faça a fila em silêncio"
        ]
      }
    ],
    "phrases": [
      "Assinatura dos pais",
      "Trazer correção amanhã",
      "Devolver autorização",
      "Trazer garrafinha",
      "Trazer agasalho",
      "Vir de tênis na Ed. Física",
      "Ditado amanhã",
      "Devolver livro"
    ],
    "duties": [
      "Fila",
      "Lousa",
      "Folhas",
      "Reciclagem",
      "Luzes",
      "Porta"
    ]
  },
  "certificate": {
    "awards": [
      {
        "id": "star",
        "label": "Aluno destaque",
        "title": "Aluno Destaque",
        "phrases": [
          "Por brilhar todos os dias com dedicação, gentileza e uma ótima atitude.",
          "Por ser um exemplo maravilhoso para toda a nossa turma.",
          "Por dar sempre o seu melhor e iluminar a nossa sala de aula."
        ],
        "suffix": ""
      },
      {
        "id": "improved",
        "label": "Maior evolução",
        "title": "Maior Evolução",
        "phrases": [
          "Por se esforçar durante todo o ano e conquistar um progresso incrível.",
          "Por nunca desistir, mesmo quando foi difícil. Veja só o quanto você evoluiu!"
        ],
        "suffix": ""
      },
      {
        "id": "reading",
        "label": "Campeão de leitura",
        "title": "Campeão de Leitura",
        "phrases": [
          "Por ler tantos livros incríveis e compartilhar seu amor pelas histórias.",
          "Por ter sempre um livro na mão e uma boa história para contar."
        ],
        "suffix": ""
      },
      {
        "id": "attendance",
        "label": "Presença exemplar",
        "title": "Presença Exemplar",
        "phrases": [
          "Por estar presente e no horário todos os dias.",
          "Por chegar com disposição para aprender em todos os dias do período."
        ],
        "suffix": ""
      },
      {
        "id": "kindness",
        "label": "Prêmio gentileza",
        "title": "Prêmio Gentileza",
        "phrases": [
          "Por demonstrar sempre gentileza, carinho e prontidão para ajudar os colegas.",
          "Por fazer com que todos na nossa turma se sintam bem-vindos e acolhidos."
        ],
        "suffix": ""
      },
      {
        "id": "math",
        "label": "Craque da matemática",
        "title": "Craque da Matemática",
        "phrases": [
          "Pelo raciocínio esperto e pelo gosto verdadeiro em resolver problemas.",
          "Pela dedicação na matemática e por nunca fugir de um bom desafio."
        ],
        "suffix": ""
      },
      {
        "id": "helper",
        "label": "Grande ajudante",
        "title": "Grande Ajudante",
        "phrases": [
          "Por ter sempre iniciativa para ajudar na sala e apoiar os colegas.",
          "Por ser uma companhia prestativa e de confiança para todos da turma."
        ],
        "suffix": ""
      },
      {
        "id": "speller",
        "label": "Mestre da escrita",
        "title": "Mestre da Escrita",
        "phrases": [
          "Por se dedicar à ortografia e dominar até as palavras mais difíceis.",
          "Pelo capricho e atenção na escrita de todas as suas atividades."
        ],
        "suffix": ""
      },
      {
        "id": "creative",
        "label": "Mente criativa",
        "title": "Mente Criativa",
        "phrases": [
          "Por ter ideias brilhantes, muita imaginação e pensar de um jeito único.",
          "Por encontrar formas criativas de resolver problemas e compartilhar ideias."
        ],
        "suffix": ""
      },
      {
        "id": "leadership",
        "label": "Liderança",
        "title": "Prêmio de Liderança",
        "phrases": [
          "Por liderar pelo exemplo e inspirar o melhor nos outros.",
          "Por mostrar uma liderança responsável e respeitosa em nossa sala de aula."
        ],
        "suffix": ""
      },
      {
        "id": "citizen",
        "label": "Cidadania exemplar",
        "title": "Cidadania Exemplar",
        "phrases": [
          "Por agir com respeito, responsabilidade e justiça com todos.",
          "Por tornar nossa turma e nossa escola um lugar melhor para todos."
        ],
        "suffix": ""
      },
      {
        "id": "worker",
        "label": "Grande dedicação",
        "title": "Grande Dedicação",
        "phrases": [
          "Por sempre dar o seu melhor, todos os dias.",
          "Por manter o foco e se dedicar muito em cada tarefa."
        ],
        "suffix": ""
      },
      {
        "id": "science",
        "label": "Estrela da ciência",
        "title": "Estrela da Ciência",
        "phrases": [
          "Por fazer perguntas curiosas, observações cuidadosas e ótimos experimentos.",
          "Pelo seu amor em descobrir como o mundo funciona."
        ],
        "suffix": ""
      },
      {
        "id": "writing",
        "label": "Prêmio de escrita",
        "title": "Prêmio de Escrita",
        "phrases": [
          "Por criar histórias criativas e textos cuidadosos e bem escritos.",
          "Pelo esforço em deixar sua escrita clara, caprichada e interessante."
        ],
        "suffix": ""
      },
      {
        "id": "sportsmanship",
        "label": "Espírito esportivo",
        "title": "Prêmio de Espírito Esportivo",
        "phrases": [
          "Por jogar limpo, incentivar os colegas e mostrar grande espírito de equipe.",
          "Por vencer com elegância, perder com um sorriso e sempre dar o seu melhor."
        ],
        "suffix": ""
      },
      {
        "id": "artist",
        "label": "Prêmio de artes",
        "title": "Prêmio de Artes",
        "phrases": [
          "Por criar trabalhos artísticos coloridos e cheios de imaginação que nos fazem sorrir.",
          "Pela criatividade e pelo capricho em tudo o que você faz."
        ],
        "suffix": ""
      },
      {
        "id": "attitude",
        "label": "Atitude positiva",
        "title": "Atitude Positiva",
        "phrases": [
          "Pelo sorriso alegre e pela disposição positiva todos os dias.",
          "Por manter a positividade e ajudar os outros a fazerem o mesmo."
        ],
        "suffix": ""
      },
      {
        "id": "listener",
        "label": "Escuta atenta",
        "title": "Escuta Atenta",
        "phrases": [
          "Por ouvir com atenção e seguir as orientações todos os dias.",
          "Por ouvir os outros com paciência e respeito."
        ],
        "suffix": ""
      },
      {
        "id": "teamwork",
        "label": "Trabalha bem em grupo",
        "title": "Espírito de Equipe",
        "phrases": [
          "Por trabalhar bem com os colegas e ajudar seu grupo a ter sucesso.",
          "Por compartilhar ideias, respeitar a vez do outro e ouvir sua equipe."
        ],
        "suffix": ""
      },
      {
        "id": "eco",
        "label": "Defesa da natureza",
        "title": "Defesa da Natureza",
        "phrases": [
          "Por cuidar do nosso planeta reciclando, economizando energia e mantendo nossa escola sustentável.",
          "Por ajudar a manter nossa sala de aula e nossa escola limpas e sustentáveis."
        ],
        "suffix": ""
      }
    ],
    "thanks": [
      {
        "id": "volunteer",
        "label": "Voluntariado escolar",
        "title": "Agradecimento",
        "phrases": [
          "Por dedicar generosamente seu tempo para ajudar em nossa sala de aula. Não conseguiríamos sem você!",
          "Pelo seu tempo, energia e gentileza ao longo de todo o ano."
        ],
        "suffix": ""
      },
      {
        "id": "parent",
        "label": "Família parceira",
        "title": "Agradecimento",
        "phrases": [
          "Por toda a sua ajuda em nossa sala de aula e pelo apoio a cada criança.",
          "Por trabalhar ao nosso lado este ano para ajudar nossos alunos a crescerem."
        ],
        "suffix": ""
      },
      {
        "id": "room-parent",
        "label": "Representante das famílias",
        "title": "Agradecimento",
        "phrases": [
          "Por organizar festas, eventos e muito mais para nossa turma este ano.",
          "Por manter as famílias da turma conectadas e nossas comemorações funcionando perfeitamente."
        ],
        "suffix": ""
      },
      {
        "id": "speaker",
        "label": "Palestrante convidado(a)",
        "title": "Agradecimento",
        "phrases": [
          "Por visitar nossa turma e compartilhar seu conhecimento e experiência conosco.",
          "Por uma visita inspiradora que despertou a curiosidade e muitas perguntas em todos."
        ],
        "suffix": ""
      },
      {
        "id": "aide",
        "label": "Auxiliar de sala",
        "title": "Agradecimento",
        "phrases": [
          "Pela sua paciência, carinho e dedicação com nossos alunos todos os dias.",
          "Por todas as formas como você apoia nosso aprendizado e nossa sala de aula."
        ],
        "suffix": ""
      },
      {
        "id": "chaperone",
        "label": "Acompanhante de passeio",
        "title": "Agradecimento",
        "phrases": [
          "Por ajudar a manter todos seguros e felizes em nosso passeio escolar.",
          "Por participar da nossa aventura e ajudar a torná-la um dia inesquecível."
        ],
        "suffix": ""
      },
      {
        "id": "donation",
        "label": "Doação generosa",
        "title": "Agradecimento",
        "phrases": [
          "Pela sua generosa doação de livros e materiais para nossa sala de aula.",
          "Pela sua gentileza em apoiar nossa turma e oferecer mais oportunidades de descoberta aos nossos alunos."
        ],
        "suffix": ""
      },
      {
        "id": "student-teacher",
        "label": "Estagiário(a) docente",
        "title": "Agradecimento",
        "phrases": [
          "Por trazer energia, criatividade e carinho para nossa sala de aula.",
          "Pelo seu esforço e dedicação. Nossos alunos adoraram aprender com você!"
        ],
        "suffix": ""
      },
      {
        "id": "class-helper",
        "label": "Ajudante do dia",
        "title": "Agradecimento",
        "phrases": [
          "Por ajudar na sala e apoiar os colegas todos os dias sem precisar pedir.",
          "Por ser uma ajuda confiável que faz nossa sala de aula funcionar muito bem."
        ],
        "suffix": ""
      }
    ],
    "closings": {
      "award": "Continue com o ótimo trabalho!",
      "thanks": "Com nossos sinceros agradecimentos."
    },
    "labels": {
      "award": "Certificado de Conquista",
      "thanks": "Certificado de Agradecimento"
    },
    "awardTitle": "Certificado de Conquista",
    "suffixes": [],
    "signers": [
      "Professor(a)",
      "Direção",
      ""
    ],
    "dateStyles": [
      "ad",
      "blank"
    ],
    "papers": [
      "a4",
      "letter"
    ],
    "limits": {
      "title": 30,
      "phrase": 120,
      "field": 40
    },
    "defaults": {
      "kind": "award",
      "preset": {
        "award": "star",
        "thanks": "volunteer"
      },
      "customTitle": "",
      "phrase": 0,
      "customPhrase": "",
      "suffix": null,
      "template": "forest",
      "nameStyle": "blank",
      "school": "",
      "className": "",
      "signer": "Professor(a)",
      "teacher": "",
      "dateStyle": "ad",
      "date": "",
      "closing": true,
      "paper": "a4"
    }
  },
  "charades": [
    {
      "id": "animals",
      "name": "Animais",
      "easy": [
        "gato",
        "cachorro",
        "coelho",
        "macaco",
        "elefante",
        "girafa",
        "leão",
        "tigre",
        "pinguim",
        "canguru",
        "sapo",
        "cobra",
        "crocodilo",
        "tartaruga",
        "caranguejo",
        "passarinho",
        "galinha",
        "pato",
        "porco",
        "vaca",
        "cavalo",
        "ovelha",
        "urso",
        "borboleta",
        "abelha",
        "peixinho dourado",
        "polvo",
        "baleia",
        "ratinho",
        "coruja",
        "caracol",
        "aranha",
        "dinossauro",
        "zebra"
      ],
      "hard": [
        "pavão",
        "camelo",
        "rinoceronte",
        "pica-pau",
        "camaleão",
        "golfinho",
        "tubarão",
        "formiga",
        "mosquito",
        "morcego",
        "foca",
        "água-viva",
        "flamingo",
        "porco-espinho",
        "bicho-preguiça",
        "esquilo",
        "gorila",
        "águia",
        "lagarta"
      ]
    },
    {
      "id": "jobs",
      "name": "Profissões",
      "easy": [
        "professor",
        "médico",
        "enfermeiro",
        "policial",
        "bombeiro",
        "cozinheiro",
        "fazendeiro",
        "carteiro",
        "cabeleireiro",
        "artista",
        "cantor",
        "mágico",
        "astronauta",
        "piloto de avião",
        "dentista",
        "veterinário",
        "motorista de ônibus",
        "salva-vidas",
        "padeiro",
        "fotógrafo",
        "palhaço",
        "bailarino",
        "mecânico",
        "operador de caixa",
        "pedreiro",
        "tratador de zoológico",
        "bibliotecário",
        "jardineiro",
        "guarda de trânsito"
      ],
      "hard": [
        "repórter",
        "advogado",
        "juiz",
        "cientista",
        "arqueólogo",
        "engenheiro",
        "carpinteiro",
        "alfaiate",
        "apresentador de jornal",
        "guia turístico",
        "comissário de bordo",
        "maestro",
        "encanador",
        "capitão de navio",
        "inventor",
        "escultor",
        "diretor de cinema",
        "escritor",
        "apresentador do tempo",
        "detetive",
        "cirurgião"
      ]
    },
    {
      "id": "sports",
      "name": "Esportes e brincadeiras",
      "easy": [
        "corrida",
        "natação",
        "pular corda",
        "basquete",
        "futebol",
        "beisebol",
        "vôlei",
        "pingue-pongue",
        "badminton",
        "andar de skate",
        "andar de bicicleta",
        "patinação no gelo",
        "cabo de guerra",
        "salto em altura",
        "salto em distância",
        "fazer trilha",
        "ginástica olímpica",
        "bambolê",
        "boliche",
        "tênis",
        "mergulho",
        "surfe",
        "esquiar na neve",
        "queimada",
        "flexão de braço",
        "amarelinha",
        "pega-pega",
        "esconde-esconde",
        "caratê",
        "dança das cadeiras"
      ],
      "hard": [
        "levantamento de peso",
        "esgrima",
        "golfe",
        "remo",
        "salto com vara",
        "arremesso de peso",
        "lançamento de dardo",
        "corrida com barreiras",
        "luta de sumô",
        "judô",
        "escalada",
        "patinação artística",
        "maratona",
        "voar de asa-delta",
        "andar de caiaque",
        "fazer abdominal",
        "ioga",
        "snowboard",
        "tiro com arco",
        "corrida de revezamento"
      ]
    },
    {
      "id": "food",
      "name": "Comidas",
      "easy": [
        "maçã",
        "banana",
        "melancia",
        "uva",
        "abacaxi",
        "morango",
        "sorvete",
        "bolo",
        "hambúrguer",
        "batata frita",
        "pizza",
        "pão",
        "sanduíche",
        "espaguete",
        "ovo frito",
        "espiga de milho",
        "pirulito",
        "pipoca",
        "cachorro-quente",
        "biscoito",
        "leite",
        "algodão-doce",
        "chocolate",
        "laranja",
        "cenoura",
        "queijo",
        "panqueca",
        "cereal matinal",
        "taco mexicano",
        "sopa"
      ],
      "hard": [
        "sushi",
        "brócolis",
        "pretzel",
        "burrito",
        "limonada",
        "pasta de amendoim",
        "cupcake",
        "waffle",
        "vitamina de frutas",
        "salada",
        "macarrão instantâneo",
        "pastelzinho chinês",
        "coco",
        "abacate",
        "picles",
        "manga",
        "marshmallow",
        "chiclete de bola",
        "pimenta",
        "almôndega"
      ]
    },
    {
      "id": "actions",
      "name": "Ações",
      "easy": [
        "escovar os dentes",
        "lavar o rosto",
        "tomar banho",
        "dormir",
        "comer",
        "beber água",
        "vestir a roupa",
        "amarrar o tênis",
        "pentear o cabelo",
        "bocejar",
        "espirrar",
        "bater palmas",
        "dar tchau",
        "pular",
        "engatinhar",
        "subir escada",
        "dançar",
        "cantar",
        "rir",
        "chorar",
        "fazer bolha de sabão",
        "empinar pipa",
        "regar as plantas",
        "passear com o cachorro",
        "ler um livro",
        "tirar uma foto",
        "abrir uma porta",
        "varrer o chão",
        "lavar a louça",
        "dar um abraço"
      ],
      "hard": [
        "calçar a meia",
        "assoar o nariz",
        "cortar as unhas",
        "passar roupa",
        "virar uma panqueca no ar",
        "secar o cabelo",
        "dobrar a roupa",
        "dar nó na gravata",
        "andar de elevador",
        "atravessar a rua",
        "carregar uma caixa pesada",
        "procurar as chaves",
        "levar uma picada de mosquito",
        "pisar no chiclete",
        "tirar uma selfie",
        "alongar o corpo",
        "fazer malabarismo",
        "andar na ponta do pé",
        "tremer de frio",
        "fazer tricô",
        "pintar uma parede"
      ]
    },
    {
      "id": "school",
      "name": "Na escola",
      "easy": [
        "lápis",
        "borracha",
        "mochila",
        "tesoura",
        "cola em bastão",
        "giz de cera",
        "régua",
        "carteira escolar",
        "quadro branco",
        "caderno",
        "lancheira",
        "garrafinha de água",
        "recreio",
        "levantar a mão",
        "fazer fila",
        "dever de casa",
        "ditado",
        "hora do lanche",
        "escorregador",
        "balanço",
        "gangorra",
        "apontar o lápis",
        "parquinho",
        "mostrar um brinquedo para a turma",
        "hora da história",
        "pincel",
        "estojo",
        "ônibus escolar",
        "trepa-trepa"
      ],
      "hard": [
        "microscópio",
        "globo terrestre",
        "calculadora",
        "experiência de ciências",
        "dicionário",
        "tabuada",
        "treinamento de incêndio",
        "passeio da escola",
        "peça de teatro da escola",
        "formatura",
        "foto da turma",
        "gincana esportiva",
        "carteirinha da biblioteca",
        "mural de recados",
        "grampeador",
        "marca-texto",
        "crachá para sair da sala",
        "concurso de soletração",
        "feira do livro"
      ]
    },
    {
      "id": "home",
      "name": "Coisas de casa",
      "easy": [
        "cama",
        "travesseiro",
        "cobertor",
        "sofá",
        "mesa",
        "cadeira",
        "abajur",
        "janela",
        "banheira",
        "escova de dentes",
        "toalha",
        "sabonete",
        "espelho",
        "televisão",
        "geladeira",
        "forno",
        "relógio de parede",
        "telefone",
        "copo",
        "colher",
        "garfo",
        "prato",
        "ursinho de pelúcia",
        "vassoura",
        "lixeira",
        "máquina de lavar roupa",
        "guarda-chuva",
        "patinho de borracha",
        "pia",
        "chave"
      ],
      "hard": [
        "aspirador de pó",
        "micro-ondas",
        "torradeira",
        "campainha",
        "ventilador de teto",
        "estante de livros",
        "cesto de roupa suja",
        "lava-louças",
        "despertador",
        "secador de cabelo",
        "liquidificador",
        "controle remoto",
        "beliche",
        "lanterna",
        "cabide",
        "caixa de correio",
        "interruptor",
        "alarme de incêndio"
      ]
    },
    {
      "id": "places",
      "name": "Lugares",
      "easy": [
        "parque",
        "praia",
        "zoológico",
        "fazenda",
        "biblioteca",
        "hospital",
        "supermercado",
        "aeroporto",
        "estação de trem",
        "padaria",
        "piscina",
        "floresta",
        "montanha",
        "rio",
        "castelo",
        "museu",
        "restaurante",
        "quartel de bombeiros",
        "pet shop",
        "loja de brinquedos",
        "ponto de ônibus",
        "jardim",
        "deserto",
        "ilha",
        "selva",
        "caverna",
        "circo",
        "cinema"
      ],
      "hard": [
        "aquário",
        "banco",
        "agência dos correios",
        "salão de beleza",
        "consultório do dentista",
        "pista de boliche",
        "parque de diversões",
        "vulcão",
        "farol do mar",
        "arranha-céu",
        "acampamento",
        "cachoeira",
        "obra de construção",
        "lavanderia",
        "posto de gasolina",
        "feira livre",
        "estação espacial",
        "casa mal-assombrada",
        "iglu"
      ]
    },
    {
      "id": "feelings",
      "name": "Sentimentos",
      "easy": [
        "feliz",
        "triste",
        "bravo",
        "assustado",
        "surpreso",
        "cansado",
        "com sono",
        "com fome",
        "com sede",
        "animado",
        "entediado",
        "tímido",
        "bobo",
        "orgulhoso",
        "com frio",
        "com calor",
        "doente",
        "mal-humorado",
        "preocupado",
        "corajoso",
        "calmo",
        "sozinho",
        "aconchegado",
        "tonto",
        "confuso",
        "com cócegas"
      ],
      "hard": [
        "nervoso",
        "com vergonha",
        "frustrado",
        "com ciúmes",
        "decepcionado",
        "curioso",
        "aliviado",
        "agradecido",
        "impaciente",
        "confiante",
        "com nojo",
        "chocado",
        "esperançoso",
        "teimoso",
        "sorrateiro",
        "exausto",
        "determinado",
        "intrigado"
      ]
    },
    {
      "id": "seasons",
      "name": "Datas especiais e estações",
      "easy": [
        "festa de aniversário",
        "soprar as velinhas",
        "abrir um presente",
        "fogos de artifício",
        "boneco de neve",
        "guerra de bola de neve",
        "escorregar de trenó",
        "juntar folhas secas",
        "pular em poças de água",
        "arco-íris",
        "óculos de sol",
        "castelo de areia",
        "picolé",
        "piquenique",
        "plantar sementinhas",
        "abóbora",
        "festa à fantasia",
        "desfile",
        "chocolate quente",
        "luvas de lã",
        "cachecol",
        "protetor solar",
        "tempestade com trovões",
        "bola de praia",
        "ir acampar",
        "folhas caindo"
      ],
      "hard": [
        "contagem regressiva de Ano-Novo",
        "pedir doces ou travessuras",
        "esculpir uma abóbora",
        "colher maçãs no pé",
        "embrulhar um presente",
        "fazer um pedido",
        "faxina de primavera",
        "férias de verão",
        "onda de calor",
        "nevasca",
        "chuva de granizo",
        "festa de outono",
        "reunião de família",
        "dia de neve sem aula",
        "casinha de biscoito",
        "caça aos ovos de Páscoa",
        "velinha estrelinha",
        "passeio na carroça de feno",
        "barraquinha de limonada"
      ]
    }
  ],
  "grades": [
    {
      "label": "Educação Infantil",
      "options": [
        {
          "value": "k1",
          "label": "Educação Infantil (3–4 anos)"
        },
        {
          "value": "k2",
          "label": "Educação Infantil (4–5 anos)"
        },
        {
          "value": "k3",
          "label": "Educação Infantil (5–6 anos)"
        }
      ]
    },
    {
      "label": "Ensino Fundamental - Anos Iniciais",
      "options": [
        {
          "value": "g1",
          "label": "1º ano do Ensino Fundamental"
        },
        {
          "value": "g2",
          "label": "2º ano do Ensino Fundamental"
        },
        {
          "value": "g3",
          "label": "3º ano do Ensino Fundamental"
        },
        {
          "value": "g4",
          "label": "4º ano do Ensino Fundamental"
        },
        {
          "value": "g5",
          "label": "5º ano do Ensino Fundamental"
        }
      ]
    },
    {
      "label": "Ensino Fundamental - Anos Finais",
      "options": [
        {
          "value": "g6",
          "label": "6º ano do Ensino Fundamental"
        },
        {
          "value": "g7",
          "label": "7º ano do Ensino Fundamental"
        },
        {
          "value": "g8",
          "label": "8º ano do Ensino Fundamental"
        },
        {
          "value": "g9",
          "label": "9º ano do Ensino Fundamental"
        }
      ]
    },
    {
      "label": "Ensino Médio",
      "options": [
        {
          "value": "g10",
          "label": "1ª série do Ensino Médio"
        },
        {
          "value": "g11",
          "label": "2ª série do Ensino Médio"
        },
        {
          "value": "g12",
          "label": "3ª série do Ensino Médio"
        }
      ]
    },
    {
      "label": "Outras modalidades",
      "options": [
        {
          "value": "mixed",
          "label": "Turma multisseriada / Contraturno"
        },
        {
          "value": "adult",
          "label": "Ensino Superior / Educação de Adultos"
        },
        {
          "value": "other",
          "label": "Outro / Não se aplica"
        }
      ]
    }
  ],
  "comments": {
    "traits": {
      "focus": {
        "kw": "a escuta atenta nas aulas",
        "lines": [
          "{N} escuta com atenção nas aulas e acompanha cada explicação de perto.",
          "{○○ demonstra|Você demonstra} muito foco nos estudos e mantém a atenção nas atividades durante as aulas.",
          "Durante as aulas, {N} mantém o olhar em quem está falando e compreende as instruções logo na primeira vez.",
          "A capacidade de concentração {de ○○|que você tem} ajuda {○○|você} a aprender novos conteúdos rapidamente.",
          "Mesmo quando a sala está agitada, {N} mantém o foco na atividade em andamento.",
          "{○○ escuta|Você escuta} as instruções com atenção e começa a atividade sem demora."
        ]
      },
      "effort": {
        "kw": "a dedicação aos estudos",
        "lines": [
          "{N} se dedica de verdade a cada atividade e sente orgulho de fazer um bom trabalho.",
          "{○○ demonstrou|Você demonstrou} muita dedicação aos estudos ao longo do período.",
          "{N} dá o seu melhor em cada atividade, seja ela fácil ou difícil.",
          "O esforço é um dos maiores pontos fortes {de ○○|que você tem}.",
          "{○○ dedica|Você dedica} com disposição o tempo necessário para fazer um trabalho bem-feito.",
          "Fica evidente que {○○ leva|você leva} o aprendizado a sério e busca sempre dar o seu melhor."
        ]
      },
      "homework": {
        "kw": "as lições de casa completas e caprichadas",
        "lines": [
          "{N} entrega sempre a lição de casa completa, caprichada e no prazo.",
          "As atividades {de ○○|que você faz} mostram cuidado e atenção aos detalhes.",
          "A lição de casa é entregue no prazo e demonstra muito capricho.",
          "{N} realiza as atividades de forma completa e as apresenta com capricho.",
          "{○○ leva|Você leva} a lição de casa a sério, e isso transparece na qualidade do trabalho.",
          "A lição de casa {de ○○|que você entrega} está sempre organizada, completa e bem elaborada."
        ]
      },
      "speak": {
        "kw": "a participação confiante",
        "lines": [
          "{N} participa ativamente das rodas de conversa e compartilha ideias com confiança.",
          "{○○ está|Você está} sempre com disposição para levantar a mão e contribuir nas discussões da turma.",
          "{N} tem iniciativa para compartilhar ideias e enriquece muito as conversas em sala.",
          "As discussões em sala ficam mais ricas graças às contribuições cuidadosas {de ○○|que você traz}.",
          "{○○ se expressa|Você se expressa} com confiança e complementa as ideias dos colegas.",
          "Quando uma pergunta é feita, {N} costuma ser uma das primeiras pessoas a responder."
        ]
      },
      "curious": {
        "kw": "a curiosidade natural",
        "lines": [
          "{N} traz uma curiosidade natural para o aprendizado e costuma fazer perguntas muito pertinentes.",
          "{○○ demonstra|Você demonstra} entusiasmo para explorar novas ideias e entender como as coisas funcionam.",
          "A curiosidade {de ○○|que você tem} gera ótimas perguntas que ajudam toda a turma a refletir com mais profundidade.",
          "{N} adora descobrir por que as coisas acontecem e como funcionam.",
          "Novos temas despertam o interesse {de ○○|em você}, e {○○ tem|você tem} sempre muita vontade de aprender mais.",
          "{○○ faz|Você faz} perguntas que demonstram reflexão e uma vontade genuína de compreender."
        ]
      },
      "reading": {
        "kw": "o gosto pela leitura",
        "lines": [
          "{N} tem um gosto genuíno pela leitura e está frequentemente com um livro nas mãos.",
          "Os hábitos de leitura {de ○○|que você tem} ajudaram a construir um vocabulário rico e um amplo conhecimento.",
          "{N} lê bastante e gosta de conversar sobre seus livros favoritos.",
          "O momento de leitura é claramente um dos pontos altos do dia {de ○○|para você}.",
          "{○○ escolhe|Você escolhe} os livros com entusiasmo e lê com cada vez mais fluência e compreensão.",
          "O gosto pelos livros transparece no vocabulário e nas produções escritas {de ○○|que você faz}."
        ]
      },
      "careful": {
        "kw": "o trabalho cuidadoso e preciso",
        "lines": [
          "{N} trabalha com cuidado e confere se está tudo certo antes de entregar as atividades.",
          "{○○ presta|Você presta} muita atenção aos detalhes em cada tarefa.",
          "{N} dedica o tempo necessário para acertar os detalhes e raramente faz as atividades com pressa.",
          "O trabalho {de ○○|que você realiza} é preciso, completo e apresentado com capricho.",
          "{○○ revisa|Você revisa} as respostas com atenção e corrige pequenos deslizes antes de entregar a atividade.",
          "A atenção aos detalhes é um grande ponto forte nas atividades diárias {de ○○|que você realiza}."
        ]
      },
      "selfdriven": {
        "kw": "autonomia e iniciativa",
        "lines": [
          "{N} toma iniciativa nos estudos e conclui as tarefas sem precisar de lembretes.",
          "{○○ tem|Você tem} motivação própria para aprender e sempre busca formas de melhorar.",
          "{N} começa as tarefas prontamente e trabalha muito bem com autonomia.",
          "{○○ define|Você define} metas pessoais e se esforça de forma constante para alcançá-las.",
          "Sem que ninguém peça, {N} frequentemente procura maneiras de aprender mais.",
          "{○○ demonstra|Você demonstra} motivação para aprender e precisa de poucos lembretes para manter o foco."
        ]
      },
      "persist": {
        "kw": "perseverança",
        "lines": [
          "{N} demonstra grande perseverança e continua tentando quando uma tarefa é desafiadora.",
          "{○○ não desiste|Você não desiste} facilmente e se esforça bastante para superar as dificuldades.",
          "{N} persiste quando a atividade fica difícil e leva as tarefas até o fim.",
          "Os desafios não desanimam {○○|você}; pelo contrário, {○○ tenta|você tenta} novamente com uma nova estratégia.",
          "A determinação {de ○○|que você tem} fica evidente sempre que uma tarefa exige um esforço extra.",
          "{○○ aprendeu|Você aprendeu} que os erros fazem parte do aprendizado e continua tentando."
        ]
      },
      "kind": {
        "kw": "gentileza",
        "lines": [
          "{N} demonstra gentileza e empatia com os outros.",
          "{○○ tem|Você tem} uma atitude carinhosa e atenciosa, e a turma se sente à vontade ao {lado de ○○|seu lado}.",
          "{N} percebe quando alguém precisa de apoio e acolhe com carinho.",
          "O jeito acolhedor {de ○○|que você tem} faz com que a turma se sinta valorizada e segura.",
          "Pequenos gestos de gentileza fazem parte da rotina diária {de ○○|que você tem}.",
          "{○○ trata|Você trata} as outras pessoas com delicadeza e se importa com o que elas sentem."
        ]
      },
      "honest": {
        "kw": "honestidade",
        "lines": [
          "{N} age com honestidade e assume a responsabilidade pelos próprios erros.",
          "{○○ conquistou|Você conquistou} a confiança de professores e colegas por meio da honestidade.",
          "{N} diz a verdade mesmo quando isso é difícil.",
          "A honestidade {de ○○|que você demonstra} faz com que todos confiem em {○○|você}.",
          "{○○ reconhece|Você reconhece} os próprios erros e aprende com eles.",
          "Professores e colegas sabem que podem confiar na palavra {de ○○|que você dá}."
        ]
      },
      "polite": {
        "kw": "boas maneiras",
        "lines": [
          "{N} age com educação e respeito com professores e colegas.",
          "As boas maneiras e a cortesia {de ○○|que você demonstra} são notadas por todos na escola.",
          "{N} usa expressões gentis, como \"por favor\" e \"muito agradecido(a)\", sem precisar de lembretes.",
          "O jeito educado {de ○○|que você tem} causa uma impressão positiva em todos.",
          "{○○ cumprimenta|Você cumprimenta} adultos e colegas com simpatia e fala sempre com respeito.",
          "As boas maneiras surgem naturalmente para {○○|você}, tanto na sala de aula quanto pela escola."
        ]
      },
      "responsible": {
        "kw": "um forte senso de responsabilidade",
        "lines": [
          "Sempre podemos contar com {N} para concluir as tarefas e cumprir o combinado.",
          "{○○ leva|Você leva} as responsabilidades a sério e é uma presença confiável na turma.",
          "{N} cumpre seus compromissos e merece confiança em tarefas importantes.",
          "Professores e colegas sabem que podem contar com a responsabilidade {de ○○|que você tem}.",
          "Ao receber uma tarefa, {N} a executa com cuidado até o fim.",
          "{○○ cuida|Você cuida} com responsabilidade das tarefas combinadas e dos materiais pessoais."
        ]
      },
      "positive": {
        "kw": "uma atitude positiva",
        "lines": [
          "{N} traz uma atitude alegre e positiva para a aula todos os dias.",
          "O otimismo e o bom humor {de ○○|que você traz} alegram a sala de aula.",
          "{N} começa cada dia com um sorriso e uma atitude animada.",
          "O entusiasmo {de ○○|que você demonstra} é contagiante e anima toda a turma.",
          "Mesmo quando as coisas ficam difíceis, {N} mantém o bom humor e a confiança.",
          "{○○ traz|Você traz} acolhimento e bom humor para a nossa sala de aula."
        ]
      },
      "confident": {
        "kw": "autoconfiança",
        "lines": [
          "{N} encara novos desafios com confiança.",
          "{○○ tem|Você tem} disposição para experimentar coisas novas e não tem medo de errar.",
          "{N} enfrenta tarefas novas com disposição e confiança.",
          "A confiança {de ○○|que você tem} aparece ao compartilhar atividades ou tentar algo novo.",
          "{○○ gosta|Você gosta} de encarar desafios e não foge de perguntas difíceis.",
          "{N} lida com situações novas com calma e autoconfiança."
        ]
      },
      "helpful": {
        "kw": "prestatividade",
        "lines": [
          "{N} está sempre disponível para ajudar colegas que precisam de apoio.",
          "{○○ frequentemente oferece|Você frequentemente oferece} ajuda e explica as atividades aos colegas com paciência.",
          "{N} percebe quando alguém está com dificuldade e oferece apoio imediatamente.",
          "A disposição {de ○○|que você tem} para ajudar faz uma grande diferença para os colegas.",
          "Os colegas costumam procurar {○○|você} quando precisam de ajuda, e {○○ atende|você atende} sempre com alegria.",
          "{○○ ajuda|Você ajuda} os outros sem que ninguém peça e sempre com um sorriso."
        ]
      },
      "teamwork": {
        "kw": "trabalho em equipe",
        "lines": [
          "{N} trabalha muito bem em grupo, ouvindo os colegas e dividindo as tarefas.",
          "{○○ colabora|Você colabora} muito bem em equipe e ajuda o grupo a alcançar bons resultados.",
          "{N} contribui com ideias nos trabalhos em grupo e valoriza a participação dos colegas.",
          "Nos projetos em grupo, {N} divide as tarefas de forma justa e incentiva a equipe.",
          "O espírito colaborativo {de ○○|que você tem} ajuda os grupos a trabalharem em harmonia.",
          "{○○ sabe|Você sabe} ceder e chegar a acordos para que toda a equipe tenha sucesso."
        ]
      },
      "friendly": {
        "kw": "simpatia e amizade",
        "lines": [
          "{N} convive muito bem com a turma e cultiva ótimas amizades.",
          "{○○ tem|Você tem} uma atitude amigável e acolhedora, fazendo com que todos se sintam bem-vindos.",
          "{N} faz amizades com facilidade e inclui os colegas nas brincadeiras e atividades.",
          "O jeito carinhoso e amigável {de ○○|que você tem} ajuda os colegas a se sentirem acolhidos.",
          "{○○ é|Você é} de fácil convivência e age com gentileza com todos.",
          "Os colegas gostam muito da {companhia de ○○|sua companhia}, tanto nas aulas quanto nas brincadeiras."
        ]
      },
      "leader": {
        "kw": "liderança",
        "lines": [
          "{N} demonstra ótimas habilidades de liderança e conduz os trabalhos em grupo muito bem.",
          "{○○ exerce|Você exerce} uma liderança natural que inspira a admiração dos colegas.",
          "{N} toma a frente nas atividades em grupo sem deixar de ouvir os colegas.",
          "Os colegas respeitam as ideias {de ○○|que você traz} e gostam de colaborar.",
          "{○○ organiza|Você organiza} bem o trabalho em grupo e garante que todos possam participar.",
          "A liderança {de ○○|que você exerce} é tranquila, justa e encorajadora."
        ]
      },
      "respect": {
        "kw": "respeito ao próximo",
        "lines": [
          "{N} ouve os outros com respeito e valoriza diferentes pontos de vista.",
          "{○○ trata|Você trata} todas as pessoas com respeito.",
          "{N} aguarda a vez de falar e ouve os colegas com atenção.",
          "A atitude respeitosa {de ○○|que você demonstra} ajuda a criar um ambiente positivo em sala.",
          "{○○ aceita|Você aceita} as diferenças e fala com todos com cortesia.",
          "O respeito pelos outros fica claro na maneira como {○○ ouve|você ouve} e responde."
        ]
      },
      "share": {
        "kw": "generosidade",
        "lines": [
          "{N} compartilha ideias e materiais com os colegas com muita generosidade.",
          "{○○ gosta|Você gosta} de compartilhar o que aprendeu com os outros.",
          "{N} divide os materiais com alegria e respeita a vez de cada um com tranquilidade.",
          "O espírito generoso {de ○○|que você tem} é muito apreciado por toda a turma.",
          "{○○ compartilha|Você compartilha} ideias e recursos prontamente durante os trabalhos em grupo.",
          "Compartilhar é algo natural para {○○|você}, seja materiais, ideias ou tempo."
        ]
      },
      "tidy": {
        "kw": "organização",
        "lines": [
          "{○○ mantém|Você mantém} a carteira arrumada e os materiais bem organizados.",
          "{○○ tem|Você tem} muita organização e está sempre com tudo pronto para as aulas.",
          "O espaço de trabalho {de ○○|que você usa} está sempre arrumado, e os materiais são fáceis de encontrar.",
          "{N} mantém livros e materiais em ordem e cuida muito bem deles.",
          "Após as atividades, {N} guarda tudo rapidamente e deixa o espaço limpo.",
          "A boa organização ajuda {○○|você} a começar cada aula com tudo pronto para aprender."
        ]
      },
      "punctual": {
        "kw": "pontualidade",
        "lines": [
          "{N} chega no horário todos os dias, com disposição para aprender.",
          "{○○ administra|Você administra} bem o tempo e cumpre os prazos.",
          "{N} chega sempre no horário e já está a postos quando as aulas começam.",
          "A pontualidade ajuda {○○|você} a aproveitar ao máximo cada dia de aula.",
          "{○○ entrega|Você entrega} as atividades dentro do prazo e aproveita bem o tempo.",
          "Chegar no horário e com tudo preparado é um hábito que {○○ já domina|você já domina} muito bem."
        ]
      },
      "rules": {
        "kw": "autodisciplina",
        "lines": [
          "{N} segue as rotinas da sala e dá um ótimo exemplo para os colegas.",
          "{○○ demonstra|Você demonstra} excelente autodisciplina e respeito pelos combinados da turma.",
          "{N} compreende os combinados da turma e os segue com constância.",
          "O comportamento calmo e sensato {de ○○|que você tem} é um modelo para os colegas.",
          "{○○ faz|Você faz} boas escolhas, mesmo quando nenhum adulto está olhando.",
          "A rotina da sala flui muito bem com a ajuda e a cooperação {de ○○|que você oferece}."
        ]
      },
      "independent": {
        "kw": "autonomia",
        "lines": [
          "{N} realiza as rotinas diárias com autonomia.",
          "{○○ cuida|Você cuida} dos pertences pessoais e das tarefas sem precisar de ajuda.",
          "{N} cuida dos pertences pessoais e se prepara para cada aula sem precisar de ajuda.",
          "A autonomia {de ○○|que você demonstra} nas rotinas do dia a dia é admirável.",
          "{○○ realiza|Você realiza} as tarefas diárias com segurança e só pede ajuda quando realmente precisa.",
          "Guardar os materiais e fazer a transição entre as atividades são coisas que {○○ faz|você faz} com facilidade."
        ]
      },
      "cleaning": {
        "kw": "capricho na organização da sala",
        "lines": [
          "{N} leva a sério as tarefas de limpeza e deixa o espaço impecável.",
          "{○○ se dedica|Você se dedica} bastante no momento de arrumar e limpar a sala.",
          "{N} se empenha na hora da arrumação e presta atenção em cada cantinho.",
          "As tarefas de organização e limpeza {de ○○|que você faz} são sempre feitas com capricho e sem reclamações.",
          "{○○ tem|Você tem} orgulho de manter nossa sala de aula limpa e arrumada.",
          "Na hora de organizar a sala, podemos sempre contar com {N} para fazer um ótimo trabalho."
        ]
      },
      "cadre": {
        "kw": "compromisso como ajudante da turma",
        "lines": [
          "{N} realiza as funções de ajudante da turma com cuidado e responsabilidade.",
          "Como ajudante da turma, {○○ dá|você dá} um bom exemplo e apoia o trabalho docente.",
          "{N} assume as responsabilidades de ajudante da turma com maturidade e cuidado.",
          "O trabalho confiável {de ○○|que você faz} como ajudante da turma é um grande apoio para todos.",
          "{○○ cumpre|Você cumpre} as tarefas de ajudante sem precisar de lembretes e dá um ótimo exemplo.",
          "Nas funções de ajudante, {N} age com responsabilidade, organização e senso de justiça."
        ]
      },
      "service": {
        "kw": "espírito de colaboração",
        "lines": [
          "{N} ajuda com boa vontade nas tarefas da sala e as leva a sério.",
          "{○○ está|Você está} sempre a postos para ajudar a manter nossa sala funcionando bem.",
          "{N} se oferece prontamente quando alguma tarefa precisa ser feita.",
          "A disposição {de ○○|que você tem} para colaborar é muito valorizada por todos.",
          "{○○ se oferece|Você se oferece} para ajudar nas tarefas da sala e as realiza com capricho.",
          "Sempre que precisamos de ajuda, {N} é uma das primeiras pessoas a se oferecer."
        ]
      },
      "sports": {
        "kw": "habilidade esportiva",
        "lines": [
          "{N} se destaca em Educação Física e demonstra ótimo espírito esportivo.",
          "{○○ traz|Você traz} energia e espírito de equipe para as atividades esportivas.",
          "{N} participa com energia e habilidade na Educação Física e incentiva os colegas.",
          "A coordenação motora e o preparo físico {de ○○|que você tem} se destacam nas atividades práticas.",
          "{○○ joga|Você joga} de forma limpa, respeita as regras e mantém o espírito esportivo em todas as partidas.",
          "A Educação Física é claramente um ponto forte, e {N} se dedica ao máximo em cada atividade."
        ]
      },
      "art": {
        "kw": "talento artístico",
        "lines": [
          "{N} tem um verdadeiro talento para Arte, realizando trabalhos criativos e cheios de cor.",
          "As produções artísticas {de ○○|que você faz} demonstram imaginação e capricho.",
          "{N} usa cores e detalhes com muita atenção em seus trabalhos de Arte.",
          "Os projetos de Arte {de ○○|que você realiza} são originais e finalizados com muito cuidado.",
          "{○○ se dedica|Você se dedica} à Arte com imaginação e vontade de experimentar.",
          "A criatividade transparece em cada trabalho artístico que {○○ faz|você faz}."
        ]
      },
      "music": {
        "kw": "talento musical",
        "lines": [
          "{N} demonstra um verdadeiro talento para a música e participa com entusiasmo.",
          "{○○ tem|Você tem} bom ouvido musical e gosta de cantar e tocar.",
          "{N} canta com confiança e mantém um ritmo firme.",
          "{O entusiasmo de ○○|O seu entusiasmo} pela música traz energia às nossas aulas.",
          "{○○ aprende|Você aprende} novas músicas e ritmos rapidamente.",
          "A música é claramente uma paixão, e {N} participa com muita alegria."
        ]
      },
      "writing": {
        "kw": "boa escrita",
        "lines": [
          "{N} escreve com clareza e imaginação.",
          "{A escrita de ○○|A sua escrita} é bem organizada e demonstra um vocabulário rico.",
          "{N} usa palavras interessantes e uma estrutura clara nas produções escritas.",
          "{As histórias de ○○|As suas histórias} são criativas e muito agradáveis de ler.",
          "{○○ expressa|Você expressa} ideias por escrito com cada vez mais habilidade e riqueza de detalhes.",
          "A escrita é um verdadeiro ponto forte, e {N} gosta de criar histórias e explicações."
        ]
      },
      "creative": {
        "kw": "criatividade",
        "lines": [
          "{N} traz ideias criativas para os projetos e gosta de atividades práticas.",
          "{○○ pensa|Você pensa} com criatividade e encontra soluções originais para os problemas.",
          "{N} traz ideias originais e gosta de construir e criar coisas.",
          "{A imaginação de ○○|A sua imaginação} traz novas ideias para os projetos da turma.",
          "{○○ gosta|Você gosta} de experimentar e encontra maneiras criativas de resolver problemas.",
          "Os projetos práticos despertam {a criatividade e a inventividade de ○○|a sua criatividade e inventividade}."
        ]
      },
      "stage": {
        "kw": "clareza ao falar",
        "lines": [
          "{N} fala com clareza e confiança diante da turma.",
          "{○○|Você} se expressa muito bem nas apresentações e prende a atenção de todos.",
          "{N} apresenta trabalhos para a turma com voz clara e bom contato visual.",
          "{As apresentações de ○○|As suas apresentações} são bem preparadas e envolventes.",
          "{○○ fala|Você fala} com confiança diante do público e explica as ideias com clareza.",
          "Falar em público é algo natural para {○○|você}."
        ]
      },
      "logic": {
        "kw": "raciocínio lógico",
        "lines": [
          "{N} pensa de forma lógica e resolve problemas de mais de uma maneira.",
          "{○○ gosta|Você gosta} de problemas desafiadores e raciocina com clareza.",
          "{N} divide os problemas passo a passo e explica o raciocínio com clareza.",
          "{O raciocínio lógico de ○○|O seu raciocínio lógico} se destaca em desafios e tarefas complexas.",
          "{○○ identifica|Você identifica} padrões rapidamente e os usa para encontrar soluções.",
          "Raciocinar sobre questões difíceis é um {dos verdadeiros pontos fortes de ○○|dos seus verdadeiros pontos fortes}."
        ]
      },
      "prog_study": {
        "kw": "nítido progresso escolar",
        "lines": [
          "{N} fez um excelente progresso escolar neste período.",
          "{O esforço de ○○|O seu esforço} resultou em uma evolução constante e visível.",
          "{O desempenho de ○○|O seu desempenho} melhorou de forma constante nas matérias neste período.",
          "{N} cresceu visivelmente na aprendizagem ao longo dos últimos meses.",
          "Os avanços que {○○ conquistou|você conquistou} em sala neste período são fáceis de perceber.",
          "{○○ desenvolveu|Você desenvolveu} habilidades mais sólidas e agora enfrenta atividades mais difíceis com sucesso."
        ]
      },
      "prog_confidence": {
        "kw": "autoconfiança crescente",
        "lines": [
          "{N} ganhou confiança e agora compartilha ideias com mais facilidade.",
          "Tem sido maravilhoso ver {○○|você} ganhar mais confiança neste período.",
          "{N} agora participa das aulas com muito mais disposição do que no início do período.",
          "{A crescente autoconfiança de ○○|A sua crescente autoconfiança} aparece na forma como {○○ experimenta|você experimenta} coisas novas.",
          "{○○ tem|Você tem} demonstrado mais disposição para se expressar e compartilhar ideias.",
          "Uma nova confiança fica evidente {nas atividades e na participação de ○○|nas suas atividades e na sua participação}."
        ]
      },
      "prog_habit": {
        "kw": "melhores hábitos diários",
        "lines": [
          "{N} deu grandes passos para seguir a rotina e gerenciar o próprio comportamento com autonomia.",
          "{A concentração e os hábitos de estudo de ○○|A sua concentração e os seus hábitos de estudo} melhoraram visivelmente.",
          "{N} agora segue a rotina diária com muito mais autonomia.",
          "{A organização e o preparo de ○○|A sua organização e o seu preparo} para as aulas melhoraram bastante.",
          "{○○ passou|Você passou} a demonstrar mais tranquilidade e concentração durante as aulas.",
          "Bons hábitos ajudaram {○○|você} a aproveitar melhor cada dia de aula."
        ]
      },
      "prog_social": {
        "kw": "amizades mais fortes",
        "lines": [
          "{N} amadureceu socialmente e agora se relaciona muito bem com a turma.",
          "{○○ aprendeu|Você aprendeu} a expressar sentimentos com calma e a trabalhar bem com os outros.",
          "{N} agora trabalha com mais tranquilidade com os colegas em duplas e em grupos.",
          "{A facilidade de ○○|A sua facilidade} para lidar com diferentes colegas cresceu ao longo do período.",
          "{○○ desenvolveu|Você desenvolveu} mais paciência e compreensão com os outros.",
          "Conviver bem com os colegas ficou muito mais fácil para {○○|você} neste período."
        ]
      },
      "a_concept": {
        "kw": "uma compreensão sólida de {c}",
        "lines": [
          "Em {subj}, {N} demonstra uma compreensão sólida de {c}.",
          "{N} compreende novos conceitos em {subj} com rapidez e precisão.",
          "{N} entende bem {c} e consegue explicar as ideias principais.",
          "{A compreensão de ○○|A sua compreensão} sobre {c} é segura e continua crescendo.",
          "Quando surgem novas ideias em {subj}, {N} as conecta ao que {○○ já sabe|você já sabe}.",
          "{○○ tem|Você tem} um claro domínio dos conceitos principais em {subj}."
        ]
      },
      "a_skill": {
        "kw": "segurança em {k}",
        "lines": [
          "{N} demonstra habilidade crescente em {k}.",
          "{As habilidades de ○○|As suas habilidades} em {k} são sólidas e consistentes.",
          "{N} está ganhando confiança em {k}.",
          "{O progresso de ○○|O seu progresso} em {k} fica evidente em sala de aula.",
          "{N} se dedica de verdade a {k}.",
          "{N} realiza tarefas que envolvem {k} com cada vez mais facilidade."
        ]
      },
      "a_apply": {
        "kw": "aplicação do aprendizado",
        "lines": [
          "{N} aplica o aprendizado de {subj} a novas situações com facilidade.",
          "{N} faz boas conexões entre {subj} e o dia a dia.",
          "{N} usa o que {○○ aprendeu|você aprendeu} em {subj} para encarar novas tarefas.",
          "{○○ consegue|Você consegue} aproveitar conceitos de {subj} e usá-los de maneiras novas.",
          "{N} frequentemente relaciona o que aprende em {subj} com a vida real.",
          "{N} aplica novas habilidades de {subj} de forma prática."
        ]
      },
      "a_express": {
        "kw": "explicações claras",
        "lines": [
          "{N} explica ideias com clareza durante as conversas em {subj}.",
          "{N} compartilha ideias nas aulas de {subj} com confiança.",
          "{N} comunica ideias em {subj} com clareza, tanto oralmente quanto por escrito.",
          "{○○ compartilha|Você compartilha} o que pensa nas aulas de {subj} e ouve a opinião dos colegas.",
          "{As contribuições de ○○|As suas contribuições} nas conversas de {subj} são cuidadosas e claras.",
          "Em {subj}, {N} usa o vocabulário adequado para expressar ideias."
        ]
      },
      "a_explore": {
        "kw": "investigação cuidadosa",
        "lines": [
          "{N} faz perguntas pertinentes e explora ideias em {subj}.",
          "{N} experimenta diferentes estratégias ao resolver problemas.",
          "{N} gosta de investigar questões em {subj} e buscar respostas.",
          "{A curiosidade de ○○|A sua curiosidade} em {subj} leva a ótimas perguntas.",
          "{○○ tem|Você tem} disposição para testar ideias e aprender com os resultados.",
          "Em {subj}, {N} pensa com cuidado e analisa as questões por diferentes ângulos."
        ]
      },
      "a_work": {
        "kw": "capricho em {w}",
        "lines": [
          "{O trabalho de ○○|O seu trabalho} em {w} é completo e feito com cuidado.",
          "{N} tem o cuidado de concluir {w} de forma completa.",
          "{N} conclui {w} com capricho e no prazo.",
          "{O desempenho de ○○|O seu desempenho} em {w} demonstra cuidado e atenção aos detalhes.",
          "{○○ tem|Você tem} orgulho de entregar {w} de forma completa e bem apresentada.",
          "O trabalho de {w} que {○○ entrega|você entrega} está sempre completo e bem apresentado."
        ]
      },
      "a_engage": {
        "kw": "participação entusiasmada",
        "lines": [
          "{N} participa com engajamento e entusiasmo das aulas de {subj}.",
          "{N} demonstra verdadeiro interesse por {subj}.",
          "{N} participa com disposição das atividades de {subj}.",
          "{O entusiasmo de ○○|O seu entusiasmo} por {subj} fica claro em todas as aulas.",
          "{○○ participa|Você participa} das aulas de {subj} com energia e atitude positiva.",
          "{N} aguarda com animação as aulas de {subj} e mantém o envolvimento do início ao fim."
        ]
      },
      "a_improve": {
        "kw": "progresso constante",
        "lines": [
          "{N} fez um progresso constante em {subj} neste período.",
          "{Os resultados de ○○|Os seus resultados} em {subj} continuam melhorando.",
          "{As habilidades de ○○|As suas habilidades} em {subj} cresceram de forma constante neste período.",
          "{N} teve avanços claros em {subj} graças ao esforço constante.",
          "Ao longo do período, {○○ ganhou|você ganhou} mais confiança em {subj}.",
          "A cada mês, {N} amplia o que já aprendeu em {subj}."
        ]
      }
    },
    "wishes": {
      "w_focus": [
        "Um próximo passo para {○○|você} é manter o foco durante as aulas, o que tornará o aprendizado ainda mais proveitoso.",
        "Incentivo {○○|você} a manter a atenção na aula e deixar as distrações de lado.",
        "Praticar a escuta ativa, como olhar para quem está falando, ajudará {○○|você} a compreender cada ideia importante.",
        "Incentivo {○○|você} a deixar sobre a carteira apenas os materiais necessários para facilitar a concentração.",
        "Continuar desenvolvendo o foco nas atividades individuais ajudará {○○|você} a concluir as tarefas com confiança."
      ],
      "w_careful": [
        "Reservar um momento para revisar a atividade antes de entregar ajudará {○○|você} a evitar pequenos erros.",
        "Um próximo passo para {○○|você} é fazer as atividades com mais calma e conferir as respostas.",
        "Ler cada questão duas vezes antes de responder ajudará {○○|você} a perceber pequenos erros.",
        "Incentivo {○○|você} a usar uma pequena lista de verificação antes de entregar as atividades.",
        "Dedicar um tempo para revisar as respostas ao final de cada tarefa deixará {as atividades de ○○|as suas atividades} ainda mais precisas."
      ],
      "w_homework": [
        "Criar uma rotina diária para a lição de casa ajudará {○○|você} a entregar as tarefas no prazo.",
        "Incentivo {○○|você} a conferir a agenda todos os dias para não esquecer nenhuma tarefa.",
        "Usar uma pasta para levar e trazer as lições entre a casa e a escola ajudará a manter tudo em dia.",
        "Um próximo passo para {○○|você} é começar a lição de casa no mesmo horário todos os dias.",
        "Guardar a lição de casa pronta na mochila na noite anterior ajudará a entregá-la na escola dentro do prazo."
      ],
      "w_handwriting": [
        "Escrever com mais calma ajudará {a letra de ○○|a sua letra} a ficar mais caprichada e fácil de ler.",
        "Um próximo passo é ter mais capricho com a letra e a apresentação das atividades.",
        "Praticar o traçado das letras por alguns minutos por dia ajudará {a escrita de ○○|a sua escrita} a ficar mais caprichada.",
        "Incentivo {○○|você} a deixar espaços claros entre as palavras e a manter as letras na linha.",
        "Dedicar um pouco mais de tempo ao capricho ajudará {as boas ideias de ○○|as suas boas ideias} a se destacarem."
      ],
      "w_speak": [
        "Incentivo {○○|você} a compartilhar ideias com mais frequência nas aulas, pois {o que ○○ pensa|o que você pensa} tem muito valor.",
        "Um próximo passo é levantar a mão mais vezes e participar das conversas da turma.",
        "Treinar as ideias primeiro com um colega ajudará {○○|você} a sentir mais segurança para compartilhar com toda a turma.",
        "Incentivo {○○|você} a estabelecer a pequena meta de contribuir pelo menos uma vez em cada roda de conversa.",
        "Compartilhar {as ideias de ○○|as suas ideias} em voz alta com mais frequência ajudará os colegas a aprenderem com {○○|você} também."
      ],
      "w_emotion": [
        "Um próximo passo para {○○|você} é respirar fundo quando algo causar chateação e usar palavras para expressar o que sente.",
        "Praticar estratégias para se acalmar ajudará {○○|você} a lidar com a frustração.",
        "Expressar os sentimentos em palavras ajudará {○○|você} a receber o apoio certo rapidamente.",
        "Incentivo {○○|você} a fazer uma pequena pausa e contar até cinco quando algo parecer difícil.",
        "Um próximo passo é praticar maneiras calmas de lidar com contrariedades, como respirar devagar."
      ],
      "w_friends": [
        "Incentivo {○○|você} a ouvir as ideias dos colegas e usar palavras gentis quando houver desentendimentos.",
        "Continuar praticando a paciência com os colegas ajudará a fortalecer as amizades.",
        "Incentivo {○○|você} a convidar diferentes colegas para participar dos trabalhos em grupo e das brincadeiras.",
        "Praticar esperar a vez e compartilhar ajudará {as amizades de ○○|as suas amizades} a ficarem ainda mais fortes.",
        "Um próximo passo para {○○|você} é conversar com calma sobre os desentendimentos e buscar uma solução justa."
      ],
      "w_tidy": [
        "Dedicar um minuto por dia para arrumar {a carteira e a mochila de ○○|a sua carteira e a sua mochila} fará com que as aulas fluam melhor.",
        "Um próximo passo é manter os materiais organizados e prontos para a aula.",
        "Usar uma lista simples de verificação no fim da aula ajudará {○○|você} a manter os materiais em ordem.",
        "Incentivo {○○|você} a guardar cada material no lugar logo após o uso.",
        "Um próximo passo é manter as pastas organizadas para encontrar as folhas com facilidade."
      ],
      "w_reading": [
        "Ler por dez minutos todos os dias ajudará {○○|você} a ampliar o vocabulário e a compreensão.",
        "Incentivo {○○|você} a explorar mais livros em casa.",
        "Ler em voz alta por alguns minutos na maioria dos dias ajudará a desenvolver a fluência e a confiança.",
        "Incentivo {○○|você} a experimentar livros de novos gêneros, como não ficção ou poesia.",
        "Conversar sobre cada livro após a leitura ajudará {○○|você} a aprofundar a compreensão."
      ],
      "w_initiative": [
        "Um próximo passo para {○○|você} é pedir ajuda assim que surgir alguma dúvida.",
        "Ter mais iniciativa nos estudos ajudará {○○|você} a avançar para o próximo nível.",
        "Incentivo {○○|você} a fazer perguntas sempre que bater a curiosidade.",
        "Dar o primeiro passo para iniciar as atividades com autonomia ajudará {○○|você} a crescer nos estudos.",
        "Um próximo passo é buscar um desafio extra após terminar as atividades de aula."
      ],
      "w_rules": [
        "Incentivo {○○|você} a continuar seguindo a rotina da turma, como respeitar a vez e esperar com paciência.",
        "Um próximo passo é lembrar dos combinados da turma ao longo do dia.",
        "Continuar seguindo os combinados da turma nas transições entre atividades ajudará o dia a fluir bem.",
        "Incentivo {○○|você} a fazer uma pausa e pensar em como as escolhas afetam os colegas.",
        "Praticar esperar a vez de falar ajudará {○○|você} a demonstrar respeito pelos colegas."
      ],
      "w_confidence": [
        "Incentivo {○○|você} a encarar novos desafios com coragem, pois errar faz parte do aprendizado.",
        "Um próximo passo é {○○ confiar um pouco mais no próprio potencial|confiar um pouco mais no seu próprio potencial}.",
        "Assumir um novo desafio a cada semana ajudará {○○|você} a ganhar mais confiança.",
        "Incentivo {○○|você} a comemorar as pequenas conquistas e lembrar que o esforço é o que mais importa.",
        "Um próximo passo é tentar a opção mais desafiadora de vez em quando, sabendo que sempre haverá apoio."
      ],
      "w_time": [
        "Usar uma agenda simples para organizar a lição de casa e a revisão ajudará {○○|você} a fazer tudo com mais calma.",
        "Um próximo passo é praticar o planejamento do tempo e a priorização de tarefas.",
        "Dividir tarefas maiores em etapas menores ajudará {○○|você} a manter o ritmo.",
        "Incentivo {○○|você} a começar os trabalhos mais longos com antecedência, em vez de deixá-los para a última hora.",
        "Usar um cronômetro durante os momentos de atividade ajudará {○○|você} a manter o foco."
      ]
    },
    "areas": {
      "chinese": {
        "subj": "Língua Portuguesa",
        "c": "leitura e vocabulário",
        "k": "leitura e escrita",
        "w": "produções escritas"
      },
      "math": {
        "subj": "Matemática",
        "c": "conceitos de números e geometria",
        "k": "cálculo e resolução de problemas",
        "w": "atividades práticas"
      },
      "english": {
        "subj": "Inglês",
        "c": "vocabulário e estruturas de frases",
        "k": "compreensão auditiva e expressão oral",
        "w": "lições de Inglês"
      },
      "social": {
        "subj": "Ciências Humanas",
        "c": "temas de comunidade e história",
        "k": "pesquisa e apresentação",
        "w": "projetos"
      },
      "science": {
        "subj": "Ciências",
        "c": "conceitos essenciais de Ciências",
        "k": "observação e experimentos",
        "w": "atividades de laboratório"
      },
      "arts": {
        "subj": "Artes",
        "c": "noções básicas de arte e música",
        "k": "criação e expressão artística",
        "w": "trabalhos artísticos"
      },
      "pe": {
        "subj": "Saúde e Educação Física",
        "c": "hábitos saudáveis",
        "k": "habilidades motoras",
        "w": "atividades de Saúde e Educação Física"
      },
      "integrative": {
        "subj": "Projeto de Vida",
        "c": "autoconhecimento e habilidades para a vida",
        "k": "atividades em grupo",
        "w": "atividades propostas"
      },
      "life": {
        "subj": "Descoberta do Mundo",
        "c": "o mundo ao nosso redor",
        "k": "observação e criação",
        "w": "projetos"
      }
    },
    "frames": {
      "openings": [
        {
          "t": "Foi um prazer ter ○○ na turma neste período.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ teve um período maravilhoso.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "Que ótimo período foi este para ○○!",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "Foi uma alegria ter você em nossa turma neste período.",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○, você teve um período maravilhoso!",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○ teve um período de muitas conquistas.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "formal"
        },
        {
          "t": "{○○ demonstrou|Você demonstrou} um crescimento constante neste período.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○ mostrou|Você mostrou} cada vez mais maturidade neste período.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "{○○ tem ido|Você tem ido} muito bem nas aulas ultimamente.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "Quero compartilhar ótimas notícias sobre ○○.",
          "u": [
            "brief",
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○, ótimo trabalho hoje!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○, notei algo maravilhoso hoje!",
          "u": [
            "cheer"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "{○○ teve|Você teve} um progresso notável neste período.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Que diferença este período fez para {○○|você}!",
          "u": [
            "special"
          ],
          "f": "progress",
          "tone": "warm"
        },
        {
          "t": "Cada criança aprende no seu próprio ritmo, e ○○ está crescendo de forma constante.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "parent"
        },
        {
          "t": "Cada pessoa aprende no seu próprio ritmo, e você está crescendo de forma constante.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "child"
        },
        {
          "t": "{○○ teve|Você teve} um período bastante ativo e produtivo.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Este foi um período de verdadeiro crescimento para {○○|você}.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Foi um verdadeiro prazer dar aula para {○○|você} neste período.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Adorei conhecer melhor {○○|você} neste período.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "{○○ realizou|Você realizou} as atividades deste período com cada vez mais autonomia.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "Este relatório resume {o progresso e os pontos fortes de ○○|seu progresso e seus pontos fortes} neste período.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Aqui vai um breve resumo de como {○○ está|você está} indo.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "{○○ teve|Você teve} ótimas semanas em sala de aula.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "As coisas têm corrido muito bem para {○○|você} nas aulas.",
          "u": [
            "brief"
          ],
          "tone": "warm"
        },
        {
          "t": "Tenho alguns elogios especiais para compartilhar sobre ○○.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "Aqui vai um recadinho para celebrar ○○.",
          "u": [
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ merece um elogio especial.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "○○, aqui vai um recadinho especial para você.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○, sinta orgulho do seu esforço.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Muito bem, ○○!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "{O crescimento de ○○|Seu crescimento} neste período ficou muito evidente.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Este foi um período de verdadeiro avanço para {○○|você}.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○ deu|Você deu} passos importantes neste período.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○ está|Você está} avançando em um ritmo tranquilo, um passo de cada vez.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Aprender leva tempo, e {○○ está|você está} desenvolvendo suas habilidades de forma constante.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Fico feliz em compartilhar o que {○○ tem feito|você tem feito} tão bem neste período.",
          "u": [
            "special"
          ],
          "f": "support",
          "tone": "warm"
        }
      ],
      "fillers": [
        {
          "t": "Tem sido gratificante acompanhar o crescimento {de ○○|que você teve} ao longo destes meses.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Essas qualidades fazem de {○○|você} uma presença muito especial em nossa turma.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Agradeço pelo apoio em casa.",
          "u": [
            "term",
            "brief",
            "special"
          ],
          "p": "parent"
        },
        {
          "t": "De modo geral, {o desempenho de ○○|o seu desempenho} neste período foi consistente.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Esse progresso é fruto de uma dedicação diária e constante.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Com a prática contínua, tenho certeza de que {○○ verá|você verá} ótimos resultados.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Continuarei apoiando {○○|você} na escola.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "{○○ dedicou-se|Você se dedicou} de forma constante neste período.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "O progresso geral nesta área é muito bom.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "{N} participa bem das aulas de {subj} e conclui as atividades propostas.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{N} está desenvolvendo habilidades sólidas em {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Seu esforço não passa despercebido.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "child"
        },
        {
          "t": "{○○ adaptou-se|Você se adaptou} muito bem à rotina da nossa turma e encara cada dia com uma ótima disposição.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○ contribuiu|Você contribuiu} muito para o convívio da nossa turma neste período.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Foi um prazer ver {os pontos fortes de ○○|seus pontos fortes} se desenvolverem ao longo do período.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Ao longo do período, {○○ atendeu|você atendeu} às expectativas com dedicação constante e atitude positiva.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○ continua|Você continua} crescendo nos estudos e no convívio com a turma.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○ encara|Você encara} cada dia de aula com boa vontade e disposição.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○ tornou-se|Você se tornou} uma presença constante e confiável em nossa turma.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "O esforço que {○○ dedica|você dedica} a cada dia é fácil de notar.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○ construiu|Você construiu} ótimas relações com os colegas e professores.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Fica evidente o quanto {○○ se importa|você se importa} em ir bem na escola.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○ ganhou|Você ganhou} mais autonomia ao longo do período.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{A atitude positiva de ○○|Sua atitude positiva} ajuda toda a turma a aprender melhor.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Tem sido muito bom ver {a confiança de ○○|sua confiança} crescer semana após semana.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "{A atitude de ○○|Sua atitude} em relação aos estudos tem sido constante e positiva.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Pequenos passos constantes estão gerando um progresso real para {○○|você}.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Cada semana traz novas oportunidades para praticar, e {○○ está|você está} aproveitando muito bem cada uma delas.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "A evolução neste período mostra o que a dedicação constante pode alcançar.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{N} segue bem as orientações em {subj} e realiza as atividades com capricho.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{N} está desenvolvendo bons hábitos de estudo em {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{As atividades de ○○|Suas atividades} em {subj} neste período refletem uma dedicação constante.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "De modo geral, a dedicação demonstrada em {subj} tem sido consistente.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "Cada pequeno passo que você dá faz muita diferença.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Sua dedicação está fazendo uma verdadeira diferença.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "O esforço de ○○ não passou despercebido.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "parent"
        }
      ],
      "closings": [
        {
          "t": "{Que ○○ continue|Continue} com o ótimo trabalho!",
          "u": [
            "term",
            "brief",
            "cheer",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "{Espero que ○○ continue|Continue} com esse ótimo trabalho.",
          "u": [
            "term",
            "brief",
            "subject",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Mal posso esperar para ver {○○|você} continuar brilhando no próximo período.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Tenho certeza de que {○○ terá|você terá} um próximo período ainda melhor.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Desejo a {○○|você} muito sucesso na próxima etapa.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "{Que ○○ continue assim|Continue assim}!",
          "u": [
            "brief",
            "cheer",
            "subject"
          ]
        },
        {
          "t": "Que orgulho de você!",
          "u": [
            "cheer",
            "special"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "Continue brilhando!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Com parceria, continuaremos trabalhando para alcançar essas metas.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Parabéns {a ○○ pelo|pelo seu} ótimo trabalho neste período.",
          "u": [
            "subject",
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Tenho ótimas expectativas para tudo o que {○○ vai|você vai} conquistar no próximo período.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Que venha mais um excelente período pela frente!",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Desejo a {○○|você} um bom descanso e um ótimo começo no próximo período.",
          "u": [
            "term"
          ]
        },
        {
          "t": "{○○ pode|Você pode} se orgulhar das conquistas deste período.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Foi um privilégio dar aula para ○○ neste período.",
          "u": [
            "term"
          ],
          "p": "parent"
        },
        {
          "t": "Parabéns por toda a sua dedicação neste período.",
          "u": [
            "term"
          ],
          "p": "child"
        },
        {
          "t": "Manterei a família informada sobre o progresso de ○○.",
          "u": [
            "brief"
          ],
          "p": "parent"
        },
        {
          "t": "Coisas ótimas estão acontecendo, então {que ○○ continue|continue} em frente!",
          "u": [
            "brief",
            "cheer"
          ],
          "tone": "warm"
        },
        {
          "t": "Uma dedicação constante como essa levará {○○|você} longe.",
          "u": [
            "brief",
            "cheer",
            "special"
          ]
        },
        {
          "t": "{○○ está|Você está} no caminho certo.",
          "u": [
            "brief",
            "subject",
            "special"
          ]
        },
        {
          "t": "Mal posso esperar para ver ainda mais avanços em {subj}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "A prática contínua fortalecerá ainda mais essas conquistas.",
          "u": [
            "subject",
            "special"
          ]
        },
        {
          "t": "Muito bem, {○○ está no caminho certo|continue assim}.",
          "u": [
            "cheer",
            "brief"
          ]
        },
        {
          "t": "Você consegue!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Cada passo à frente importa, e muitos outros ainda virão.",
          "u": [
            "special"
          ],
          "f": "support"
        }
      ]
    },
    "elaborations": {
      "area": [
        "Isso reflete uma base sólida em {subj}.",
        "{O progresso de ○○|Seu progresso} em {subj} é muito animador.",
        "De modo geral, o desempenho em {subj} é bastante sólido.",
        "A qualidade {das atividades de ○○|das suas atividades} em {subj} demonstra muito capricho.",
        "Essa é uma excelente base para a próxima etapa de aprendizagem em {subj}.",
        "{○○ tem|Você tem} uma ótima base para os próximos passos em {subj}.",
        "É animador ver esse crescimento em {subj}."
      ],
      "learning": [
        "Essa postura diante dos estudos deu a {○○|você} uma base sólida nas diferentes áreas.",
        "Esses hábitos ajudarão muito {○○|você} nos próximos anos.",
        "Como resultado, {o trabalho de ○○|seu trabalho} tem sido sempre muito bom.",
        "{○○ está|Você está} construindo hábitos que levam ao sucesso duradouro.",
        "Essa constância se reflete na qualidade {das atividades diárias de ○○|das suas atividades diárias}.",
        "Com uma atitude tão positiva, é um prazer ensinar {○○|você}.",
        "Esses pontos fortes ajudam {○○|você} a aproveitar ao máximo cada aula."
      ],
      "character": [
        "Essas qualidades valem ainda mais do que as notas.",
        "{○○ conquistou|Você conquistou} o respeito dos colegas e professores.",
        "É uma alegria ver um caráter tão admirável todos os dias.",
        "Os colegas sabem que podem contar com {○○|você}.",
        "{○○ lidera|Você lidera} pelo exemplo, de forma discreta, mas muito importante.",
        "Esse tipo de atitude ajuda a construir uma turma acolhedora.",
        "Qualidades assim farão bem a {○○|você} muito além da escola."
      ],
      "social": [
        "Os colegas adoram aprender e brincar ao lado de {○○|você}.",
        "{○○ ajuda|Você ajuda} a tornar nossa sala de aula um lugar acolhedor e afetuoso.",
        "Essas habilidades sociais são um verdadeiro dom.",
        "As atividades em grupo fluem muito melhor com {○○|você} na equipe.",
        "Essas habilidades ajudam todos da turma a se sentirem incluídos.",
        "Saber trabalhar bem com os outros é uma das habilidades mais valiosas que existem.",
        "{○○ desperta|Você desperta} o melhor nas pessoas ao redor."
      ],
      "routine": [
        "Esses bons hábitos tornam o aprendizado mais eficiente.",
        "{○○ dá|Você dá} um exemplo positivo para os outros.",
        "Cuidar bem das tarefas do dia a dia é um passo importante no crescimento.",
        "Estar com tudo pronto e organizado significa mais tempo para aprender.",
        "Essas rotinas garantem a {○○|você} um começo de dia tranquilo e seguro.",
        "Bons hábitos como esses desenvolvem uma verdadeira autonomia.",
        "{○○ mostra|Você mostra} que pequenos hábitos diários fazem uma grande diferença."
      ],
      "service": [
        "Essa disposição para ajudar torna nossa turma um lugar melhor.",
        "Graças {à ajuda de ○○|à sua ajuda}, a rotina da sala flui muito melhor.",
        "Dedicar tempo para ajudar os outros é motivo de orgulho.",
        "Colaborar dessa forma demonstra muita maturidade.",
        "{○○ realiza|Você realiza} essas tarefas com alegria, o que valorizamos muito.",
        "Nossa turma fica mais unida e forte com esse tipo de ajuda.",
        "Esse espírito colaborativo é uma qualidade preciosa."
      ],
      "talent": [
        "Espero que {○○|você} continue desenvolvendo esse talento.",
        "Esse talento enriquece muito as atividades da nossa turma.",
        "É empolgante ver esse talento crescer.",
        "É maravilhoso ver {○○|você} compartilhar esse dom com a turma.",
        "{○○ tem|Você tem} todos os motivos para se orgulhar desse talento.",
        "Com a prática contínua, esse talento vai crescer cada vez mais.",
        "Esse ponto forte dá a {○○|você} a chance de brilhar de um jeito especial."
      ],
      "progress": [
        "Esse avanço não veio sem esforço e merece ser reconhecido.",
        "Fica evidente o quanto {○○ se dedicou|você se dedicou}.",
        "Fico realmente feliz em ver essa evolução.",
        "Esse crescimento mostra o que o esforço constante pode alcançar.",
        "{○○ avançou|Você avançou} muito, e isso merece ser comemorado.",
        "Cada pequeno passo somou para uma mudança real.",
        "Esse progresso é uma ótima base para os próximos meses."
      ]
    },
    "compact": [
      {
        "t": "{○○ demonstrou|Você demonstrou} muitos pontos fortes, incluindo {L}."
      },
      {
        "t": "Os destaques incluem {L}."
      },
      {
        "t": "{Os pontos fortes de ○○|Seus pontos fortes} incluem {L}."
      },
      {
        "t": "{○○ apresenta|Você apresenta} os seguintes destaques: {L}."
      },
      {
        "t": "Entre {os pontos fortes de ○○|seus pontos fortes}, destacam-se {L}."
      },
      {
        "t": "Os principais pontos fortes deste período incluem {L}.",
        "tone": "formal"
      },
      {
        "t": "Foi um prazer observar {L} ao longo do período.",
        "tone": "warm",
        "u": [
          "term",
          "brief",
          "special"
        ]
      },
      {
        "t": "Tenho satisfação em destacar {L}.",
        "tone": "formal"
      }
    ],
    "connectors": [
      "Além disso, ",
      "Também ",
      "Mais do que isso, "
    ],
    "wishLeads": [
      "",
      "",
      "Para os próximos passos, "
    ],
    "you": "você",
    "possessive": "seu/sua",
    "blankName": "[Nome]",
    "and": "e",
    "unit": "palavras"
  },
  "roster": {
    "sheet": "Lista da turma",
    "guideSheet": "Instruções",
    "seat": "Número de chamada",
    "name": "Nome do aluno",
    "group": "Grupo",
    "gender": "Gênero",
    "avatar": "Tipo de avatar",
    "instructions": [
      "Preencha apenas a aba Lista da turma, com um aluno por linha.",
      "Mantenha os cabeçalhos da primeira linha. Apenas o Nome do aluno é obrigatório.",
      "O número de chamada é opcional. Formate valores como 01 e 02 como texto para manter o zero à esquerda.",
      "Os nomes podem ter até 30 caracteres e não podem se repetir na turma. Importe até 100 alunos por vez.",
      "Importar alunos na configuração inicial é opcional. Você pode adicioná-los depois na página Alunos.",
      "Use arquivos .xlsx, .xls, .ods ou CSV em UTF-8. O formato CSV mantém apenas uma aba e texto simples.",
      "Não inclua fórmulas, macros, números de telefone, e-mails ou outros dados pessoais desnecessários dos alunos.",
      "A aba da lista está em branco. Este guia não é importado."
    ],
    "male": "masculino",
    "female": "feminino"
  },
  "demo": {
    "teacher": "Profª Mariana",
    "workspace": "Sala Demo ClassMori",
    "className": "3º Ano A - Manhã",
    "individualClassName": "3º Ano B - Guardiões",
    "cycle": "1º Ciclo de Evolução",
    "pet": "Pipoca",
    "individualPet": "Mori Amigo",
    "groups": [
      "Tucanos",
      "Araras",
      "Capivaras",
      "Micos"
    ],
    "names": [
      "Alice",
      "Arthur",
      "Beatriz",
      "Bernardo",
      "Cecília",
      "Davi",
      "Enzo",
      "Gabriel",
      "Gael",
      "Giovanna",
      "Heitor",
      "Helena",
      "Heloísa",
      "Isabella",
      "Júlia",
      "Laura",
      "Leonardo",
      "Lorena",
      "Lucas",
      "Manuela",
      "Matheus",
      "Miguel",
      "Pedro",
      "Valentina"
    ],
    "surpriseItems": [
      [
        "Cápsula da floresta",
        "🎁",
        6,
        "capsule",
        [
          [
            "Escolher um adesivo",
            "🌈",
            "common"
          ],
          [
            "Ajudante do dia",
            "🤝",
            "common"
          ],
          [
            "Escolher o lugar por um dia",
            "🪑",
            "uncommon"
          ],
          [
            "Vale sem lição de casa",
            "📝",
            "rare"
          ]
        ]
      ],
      [
        "Raspadinha da sorte",
        "🍀",
        6,
        "scratch",
        [
          [
            "Escolher música do recreio",
            "🎵",
            "common"
          ],
          [
            "Sentar com um amigo por um dia",
            "👫",
            "uncommon"
          ],
          [
            "Líder da turma por um dia",
            "👑",
            "rare"
          ]
        ]
      ]
    ],
    "routines": [
      "Leitura",
      "Debate",
      "Arrumação"
    ]
  },
  "schema": {
    "home": "Início",
    "freeTool": "ferramenta gratuita",
    "product": {
      "description": "Pontos e mascotes da turma para professores: selecione os alunos, toque em um motivo e veja os mascotes crescerem a cada ponto. Sem contas de alunos; grátis para sempre para 1 turma.",
      "free": "Plano gratuito",
      "yearly": "Plano Plus, anual",
      "monthly": "Plano Plus, mensal",
      "plus": "Plano Pro, anual",
      "plusMonthly": "Plano Pro, mensal"
    },
    "socialAlt": "ClassMori: professora e alunos em uma sala de aula na floresta com o mascote da turma"
  },
  "corePages": {
    "/": {
      "title": "ClassMori | Pontos em sala de aula que fazem crescer o mascote de cada aluno",
      "description": "Um app de pontos e mascotes da turma para professores: selecione os alunos, toque em um motivo e veja os mascotes crescerem a cada ponto. Um mascote por aluno ou um para a turma toda. Funciona no projetor ou celular, sem contas de alunos. Grátis para 1 turma de até 40 alunos."
    },
    "/about": {
      "title": "Sobre nós | ClassMori",
      "description": "Conheça o ClassMori: feedback positivo específico e companheiros da floresta que ajudam professores a acompanhar a evolução de cada criança."
    },
    "/pricing": {
      "title": "Preços | ClassMori",
      "description": "O ClassMori é grátis para sempre para 1 turma de até 40 alunos. O Plano Plus custa US$ 3 por mês ou US$ 19 por ano (US$ 9,90 no primeiro ano) para 5 turmas de 100 alunos. Também oferecemos o Plano Pro e orçamentos para escolas."
    },
    "/tour": {
      "title": "Experimente o painel do professor | ClassMori",
      "description": "Sem cadastro: teste um mascote da turma toda e um mascote para cada aluno. Selecione alunos, dê pontos e veja os mascotes mudarem. As alterações ficam só nesta página e voltam ao início ao atualizar; todos os alunos são fictícios."
    },
    "/privacy": {
      "title": "Política de privacidade | ClassMori",
      "description": "Como o ClassMori trata as contas de professores e os dados das turmas, e como solicitar seus dados."
    },
    "/terms": {
      "title": "Termos de serviço | ClassMori",
      "description": "Termos de serviço, escopo do serviço e regras de conta do ClassMori."
    },
    "/contact": {
      "title": "Fale conosco | ClassMori",
      "description": "Dúvidas, sugestões ou compra para escola? Entre em contato com a equipe do ClassMori."
    }
  },
  "scene": {
    "pets": {
      "otter": {
        "name": "Mori",
        "species": "lontra",
        "foodName": "camarão"
      },
      "rabbit": {
        "name": "Fofinho",
        "species": "coelho",
        "foodName": "cenoura"
      },
      "penguin": {
        "name": "Bolinho",
        "species": "pinguim",
        "foodName": "peixe"
      }
    },
    "lines": {
      "calm": [
        "Estou bem aqui. Faça no seu tempo.",
        "Pequenos passos também merecem ser comemorados!",
        "Tudo pronto? Vamos juntos!",
        "Um passo de cada vez nos leva um pouco mais longe.",
        "Respire fundo. Uma nova tarefinha está esperando.",
        "Tantas coisas novas para descobrir hoje!",
        "Aqui vai um pouquinho de coragem para você.",
        "Suas ideias merecem ser compartilhadas!",
        "Vamos deixar o dia de hoje bem acolhedor juntos.",
        "Adoro aprender com você!"
      ],
      "react": [
        "Own, obrigado por tanta gentileza!",
        "Obrigado, isso aquece o coração.",
        "Hehe, que alegria sermos amigos!",
        "Um toquinho, tanto carinho.",
        "Aqui está um coração bem grandão para você!",
        "O dia fica ainda mais fofo com você aqui.",
        "Vamos espalhar nosso bom humor para todo mundo!",
        "Seu carinho aquece como um solzinho.",
        "Pequenas gentilezas deixam as pessoas felizes!",
        "Meu coraçãozinho está acenando para você!"
      ],
      "wave": [
        "Oi! Vamos dar o nosso melhor hoje!",
        "Ver você me deixa tão feliz!",
        "Tchauzinho! Lá vem o bom humor!",
        "Olá! Tudo pronto para aprendermos juntos?",
        "Mande um sorriso para o colega ao seu lado!",
        "Seu \"oi\" acabou de iluminar a florestinha.",
        "Diga olá para alguém pertinho de você!",
        "Boas maneiras aquecem o coração.",
        "Um aceno, um pouquinho mais de coragem!",
        "Todos os nossos amigos estão aqui. Vamos lá!"
      ],
      "eat": [
        "Obrigado pelo alimento ({food})! Vou comer devagarinho.",
        "Você cuida dos seus amigos com tanto carinho.",
        "Um lanchinho, e depois vamos continuar!",
        "Nham! Bom humor direto para a minha barriguinha!",
        "Você cuida tão bem de mim.",
        "Compartilhar faz a felicidade crescer!",
        "Este alimento ({food}) está cheio de carinho.",
        "Minha barriguinha está pronta para um novo desafio!",
        "Obrigado por lembrar de cuidar de mim.",
        "De barriga cheia! Aqui está um sorriso para você!"
      ],
      "drink": [
        "Glup, glup, obrigado por cuidar de mim!",
        "Um gole de água e ficamos cheios de energia!",
        "Lembre-se de beber um pouco de água também!",
        "Gotinhas de água trazem bom humor.",
        "Cuidar de você é muito importante!",
        "Faça uma pausa e depois continue.",
        "Obrigado, esse gole aqueceu meu coração!",
        "Pausa para a água concluída, juntos!",
        "Quando meu corpo se sente bem, eu aprendo melhor.",
        "Refrescado e pronto para novas descobertas!"
      ],
      "stretch": [
        "Espreguice bem, a energia está voltando!",
        "Mãos lá no alto, o bom humor já vai chegar!",
        "Gire os ombros e dê força para você mesmo.",
        "Um descansinho nos ajuda a ir mais longe.",
        "Respire fundo. Vamos relaxar juntos.",
        "Da cabeça aos pés, tudo pronto!",
        "Você se esforça bastante. Cuide-se bem também.",
        "Alongue o corpo e solte um sorriso!",
        "Um pequeno descanso ajuda no próximo passo.",
        "Muito melhor! Vamos tentar de novo juntos!"
      ],
      "celebrate": [
        "Mandou bem! Aqui está uma estrela de esforço para você!",
        "Eu vi com quanto capricho você fez isso!",
        "Uma tarefa bem-feita merece aplausos!",
        "Você teve muita coragem de tentar. Incrível!",
        "Mais um pouquinho de progresso hoje. Viva!",
        "Você fez isso com tanto cuidado. Demais!",
        "Aqui vai minha torcida por você. Continue brilhando!",
        "Cada pedacinho de esforço merece ser visto!",
        "Você foi tão bem que estou pulando de alegria!",
        "Eba! Vamos todos aplaudir o seu progresso!"
      ],
      "sleep": [
        "Um descansinho para recuperar minhas energias.",
        "Ahh… Estou aqui com você na florestinha.",
        "Um momento tranquilo deixa meu coração calminho.",
        "Guardando o progresso de hoje em bons sonhos.",
        "Depois de se esforçar bastante, descanse bem também!",
        "Lá vem a luazinha trazendo sonhos aconchegantes.",
        "Feche os olhos e guarde um sorriso para você.",
        "Energias renovadas. Vamos lá de novo.",
        "Obrigado por se dedicar tanto hoje!",
        "O seu sorriso também está nos meus doces sonhos."
      ],
      "jump": [
        "Um, dois, três, pulando de alegria!",
        "Um pulinho para mandar felicidade para você!",
        "Meus pezinhos estão cheios de alegria.",
        "Dê um pulo, que a coragem também cresce um pouquinho!",
        "Vamos dar um oi para a felicidade!",
        "Pouso perfeito, grandes sorrisos!",
        "Um pulinho feliz. Vamos lá!",
        "Mais um pouquinho de risadas na floresta!",
        "Compartilhe o bom humor de hoje!",
        "Brincar com você é muito divertido!"
      ],
      "wake": [
        "Acordei! Obrigado por me acordar com tanto carinho.",
        "Uma nova tarefinha. Vamos fazer juntos!",
        "Olhinhos brilhando, humor radiante!",
        "Bem descansado. Estou cheio de energia de novo.",
        "Obrigado por esperar com tanta paciência!",
        "Uma espreguiçada e um sorriso para você.",
        "Pronto! Vamos dar um passo à frente!",
        "Dormi bem, agora estou cheio de coragem!",
        "Acordar é uma alegria quando você está aqui.",
        "A florestinha acordou. Vamos lá!"
      ],
      "read": [
        "Estou lendo um livrinho divertido.",
        "Esta página é sobre amigos na floresta.",
        "Espere, quero olhar esta página de novo.",
        "Vamos ouvir esta história juntos."
      ],
      "homework": [
        "Estou fazendo a lição de casa. Quase terminando!",
        "Escrever devagar também é escrever bem.",
        "Deixe-me pensar nisto mais um pouquinho.",
        "Pronto! Estamos todos melhorando."
      ],
      "paint": [
        "Estou pintando uma florzinha.",
        "Primeiro as pétalas, depois as folhas.",
        "Qual é a sua cor favorita?",
        "Tudo pronto! Isto é para você."
      ],
      "rope": [
        "Estou pulando corda. Mantenha o ritmo!",
        "Um, dois, um pulinho leve.",
        "A corda passou certinho debaixo dos meus pés!",
        "Mais um pulo. Que divertido!"
      ]
    }
  },
  "sceneUi": {
    "ClassMori · Forest pet scene": "ClassMori · Cenário do mascote da floresta",
    "The forest pet's little forest": "A florestinha do mascote da floresta",
    "Forest pet interactive scene": "Cenário interativo do mascote da floresta",
    "Your browser needs Canvas support to show the forest pet.": "Seu navegador precisa ter suporte a Canvas para exibir o mascote da floresta.",
    "Hi! Let's do our best today!": "Oi! Vamos dar o nosso melhor hoje!",
    "A gentle pat. Your friend in the egg heard you!": "Um carinho suave. Seu amiguinho dentro do ovo ouviu você!",
    "Knock, knock. We're waiting for you out here!": "Toc, toc. Estamos esperando por você aqui fora!",
    "Oh? A tiny sound from inside the egg!": "Oh? Um barulhinho vindo de dentro do ovo!",
    "Something is moving in the den. Let's wait quietly.": "Algo está se mexendo na toca. Vamos esperar em silêncio.",
    "Pat the egg": "Fazer carinho no ovo",
    "Knock gently": "Bater de leve",
    "Little wing": "Asinha",
    "Pat to respond": "Faça carinho para interagir",
    " · Drag to pick up": " · Arraste para pegar",
    ". Tap to get a reaction; drag to gently pick up.": ". Toque para ver uma reação; arraste para pegar com cuidado."
  },
  "languageSuggestion": {
    "region": "Idioma",
    "available": "Esta página está disponível em português",
    "view": "Ver esta página em português",
    "dismiss": "Fechar"
  },
  "heroAlt": "O modo projetor do ClassMori com alunos fictícios e seus mascotes em crescimento.",
  "sceneArrival": {
    "otter": {
      "waiting": "Crec, crec… tem algo se mexendo no oco da árvore.",
      "peek": "{name} está espiando! Tudo pronto para conhecer todo mundo.",
      "hello": "Olá! Obrigado por esperarem com tanto carinho."
    },
    "rabbit": {
      "waiting": "A cortina de folhas balança. {name} está descansando lá dentro.",
      "peek": "Orelhas compridas estão aparecendo! {name} quer dizer oi.",
      "hello": "Oi! Vamos nos esforçar e crescer juntos!"
    },
    "penguin": {
      "waiting": "O ovo deu uma mexidinha. Sua nova amizade está se preparando.",
      "peek": "A casca abriu! {name} está espiando o mundo.",
      "hello": "Piu! Obrigado por torcerem por mim. Cheguei!"
    }
  },
  "sceneRegions": {
    "ear": "Orelha direita",
    "earleft": "Orelha esquerda",
    "footleft": "Pé esquerdo",
    "footright": "Pé direito",
    "tail": "Rabo",
    "handleft": "Mãozinha",
    "wave": "Mãozinha",
    "wingleft": "Asa esquerda",
    "wingright": "Asa direita",
    "tuft": "Topete",
    "face": "Bochechas",
    "body": "Barriguinha",
    "sleep": "Acordar com carinho"
  },
  "commentLanguageFaq": {
    "question": "Posso gerar comentários em outros idiomas?",
    "answer": "Sim. Novas configurações usam o idioma desta página como padrão. Use o seletor de idioma para escolher chinês, inglês, espanhol, francês, português do Brasil, turco, vietnamita ou indonésio. Os comentários usam um banco de frases no idioma selecionado; os nomes são preenchidos localmente."
  },
  "reasonAliases": {
    "Lição em dia": "homework",
    "Trabalho em equipe": "teamwork",
    "Atenção na aula": "focus",
    "Desafio concluído": "persist",
    "Ajudando os colegas": "helpful",
    "Levantando a mão": "speak"
  }
}
